import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { 
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Spinner
} from 'reactstrap'
import RejectOptionsHOC from '../actions/rejectOption'

const ConfirmationCodeModal = ({
  open,
  mobileNum,
  showLoading,
  submitTypeId,
  rejectOptions,
  getRejectOptions,

  onClose,
  onClickSubmit,
  onClickResend,
}) => {
  const [ code, onChangeCode ] = useState( '' )
  const [ rejectReason, onChangeReject ] = useState( '' )
  const [ ownReason, onChangeOwnReason ] = useState( '' )
  const [ resendCountDown, onCountDown ] = useState( 0 )

  let isDeclined = submitTypeId % 2 === 0 
  // even number submitTypeId is declined

  useEffect(() => {
    if ( rejectReason === 0 ) {
      onChangeOwnReason( '' )
    }
  }, [ rejectReason ] )

  useEffect(() => {
    if ( !open ) {
      onChangeCode( '' )
      onChangeReject( null )
      onChangeOwnReason( '' )

    } else {
      onCountDown( 60 )
      isDeclined && getRejectOptions()
    }
  }, [ open ] )
  
  useEffect(() => {
    if ( resendCountDown > 0 && open ) {
      setTimeout(() => {
        onCountDown( resendCountDown - 1 )
      }, 1000 );
    }
  }, [ resendCountDown ])

  return (
    <Modal centered={ true } isOpen={ open }>
      <ModalHeader toggle={ () => onClose()}>
        Verification
      </ModalHeader>
      <ModalBody>
        <p>
          To confirm your signature, we've sent an SMS with a code to your mobile. Please key in the verification code below.
        </p>
        <p>{ `Mobile No: +${ mobileNum }` }</p>
        <FormGroup>
          <Label>Confirmation Code: </Label>
          <Input value={ code } onChange={ e => onChangeCode( e.target.value ) }/>
        </FormGroup>
        {
          isDeclined && (
            <FormGroup className={ 'mt-3' }>
              <Label>Reject Reason: </Label>
              <Input 
                type="select" 
                value={ rejectReason } 
                onChange={ e => onChangeReject( e.target.value )}>
                {
                  rejectOptions.map( item => (
                    <option key={ item.value } value={ item.value }>
                      { item.description }
                    </option>
                  ))
                }
              </Input>
            </FormGroup>
          )
        }
        {
          isDeclined && (
            <FormGroup className={ 'mt-3' }>
              <Label for="exampleText">My own reason: </Label>
              <Input 
                type="textarea" 
                value={ ownReason } 
                onChange={ e => onChangeOwnReason( e.target.value )}/>
            </FormGroup>
          )
        }
      </ModalBody>
      <ModalFooter className={ 'd-flex' }>
        {
          resendCountDown !== 0 && (
            <p>{ `Resend button will be shown after ${ resendCountDown } seconds` }</p>
          )
        }
        <div className={ 'ml-auto' } >
          {
            resendCountDown === 0 && (
              <Button 
                color={ 'primary mr-2' }
                onClick={ () => { 
                  onCountDown( 60 )
                  onClickResend( submitTypeId )
                }}>
                Resend Code 
              </Button>
            )
          }
          {
            !showLoading && (
              <Button 
                disabled={ 
                  isDeclined 
                    ? ( code.length < 1 || !rejectReason || ( rejectReason === '4' && ownReason.length < 1 ))
                    : code.length < 1
                }
                color="primary" 
                onClick={ () => onClickSubmit( code, rejectReason, ownReason ) }>
                Submit  
              </Button>
            )
          }
        </div>
        {
          showLoading && (
            <Spinner className={ 'ml-auto' } color="primary" />
          )
        }
      </ModalFooter>
    </Modal>
  )
}

export default RejectOptionsHOC( ConfirmationCodeModal );